<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">
                <!-- <img src="../../../assets/images/service/psihiatrie-1.jpg" alt="Psihiatrie" /> -->

                <h2>Psihiatrie – echilibru emoțional și sănătate mintală</h2>
                <p>
                  Psihiatria se ocupă cu evaluarea, diagnosticarea și tratamentul
                  afecțiunilor de sănătate mintală, având ca obiectiv principal
                  restabilirea echilibrului emoțional și îmbunătățirea calității vieții.
                </p>

                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/eduard_cocea#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img"><img src="../../../assets/images/team/member-1.jpg"
                            alt="dr-eduard-cocea"></div>
                        <div class="team-info">
                          <span>Dr. Eduard Cocea</span>
                          <!-- <span>Medic primar psihiatru</span> -->
                        </div>
                      </div>
                    </a>
                  </div>

                      <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/xenia_cocea#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img"><img src="../../../assets/images/team/member-2.jpg"
                            alt="dr-xenia-cocea"></div>
                        <div class="team-info">
                          <span>Dr. Xenia Cocea</span>
                          <!-- <span>Medic primar psihiatru</span> -->
                        </div>
                      </div>
                    </a>
                  </div>

                      <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/petronela_pascaru#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img"><img src="../../../assets/images/team/member-7.jpg"
                            alt="dr-petronela-pascaru"></div>
                        <div class="team-info">
                          <span>Dr. Petronela Pascaru</span>
                          <!-- <span>Medic primar psihiatru</span> -->
                        </div>
                      </div>
                    </a>
                  </div>
                </div>


                <h3>Servicii și evaluări disponibile</h3>
                <p>
                  În cadrul cabinetului de psihiatrie sunt oferite servicii medicale
                  specializate pentru susținerea sănătății mintale.
                </p>
                <div class="card mb-10" v-for="service in services" :key="service.name">
                  <div class="row" style="padding: 10px 20px;">
                    <div class="card-service col-xl-10 col-lg-10 col-md-10">
                      <i class="ri-check-double-line" style="vertical-align: bottom;"></i> {{ service.name }}
                    </div>
                    <div class="service-price col-xl-2 col-lg-2 col-md-2 text-align-right">
                      <!-- {{ service.price }} Lei -->
                    </div>
                  </div>
                </div>
                <div class="other-option md-none mb-40">
                  <a href="/#appointment" class="btn style2">
                    Solicită o programare
                  </a>
                </div>
               
                <h3>Întrebări frecvente</h3>
                <p>
                  Mai jos găsești răspunsuri la cele mai frecvente întrebări legate de
                  consultațiile psihiatrice.
                </p>

                <div class="accordion" id="accordionExample_one">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Când este recomandată o consultație psihiatrică?
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Consultația psihiatrică este recomandată în cazul simptomelor
                          precum anxietate, depresie, insomnie, schimbări de dispoziție,
                          stres intens sau dificultăți de adaptare.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Este necesară trimitere pentru consultație?
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Pentru consultațiile în cadrul clinicii private, nu este necesară
                          trimitere medicală. Programarea se poate face direct.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Consultația este confidențială?
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Da, consultațiile psihiatrice se desfășoară în deplină
                          confidențialitate, respectând normele medicale și drepturile
                          pacientului.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Tratamentul presupune doar medicație?
                      </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Tratamentul este stabilit individual și poate include
                          medicație, recomandări terapeutice sau colaborare cu
                          alte specialități, în funcție de nevoile pacientului.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "PsihiatriePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
      services: [
        {
          name: "Consultație psihiatrică",
          price: 300
        },
        {
          name: "Evaluare psihiatrică complexă",
          price: 200
        },
        {
          name: "Stabilirea și monitorizarea tratamentului medicamentos",
          price: 350
        },
        {
          name: "Recomandări terapeutice și de stil de viață",
          price: 200
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>